export enum AdministrationConstants {
  SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',
}
